export default "__VITE_ASSET__DJzsvzmG__"